import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import SearchData from "../components/SearchData";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import moment from "moment";
import Swal from "sweetalert2";
import SearchIcon from '@mui/icons-material/Search';
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useSelector } from "react-redux";
export default function ContainerListTrain() {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [idDialog, setIdDialog] = useState("");
  const [idEdit, setIdEdit] = useState("");
  const EmpId = localStorage.getItem("EmpId");
  const [date, setDate] = useState([]);
  const [datei, setDatei] = useState([]);
  const [stDate, setstDate] = useState(null);
  const [enDate, setenDate] = useState(null);
  const [toAction, setToAction] = useState('');
  const [bay, setBay] = useState('')
  const [row, setRow] = useState('')
  const [tier, setTier] = useState('')
  const [searchText, setSearchText] = useState('')
  const [search, setSearch] = useState({
    startDate: stDate,
    endDate: enDate,
    Keyword: '',
    ToAction: ''
  })
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer className={gridClasses.toolbarContainer}>
        <GridToolbarExport
          style={{
            color: "#84BD5A",
            borderColor: "#84BD5A",
            border: "1px solid #84BD5A",
          }}
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            fields: [
              "Status",
              "ContainerNo",
              "Size",
              "PickupVoyageNo",
              "EtdCloseingDate",
              "DateIn",
              "SoNumber",
            ],
            fileName: "ContainerListData " + new Date() + Math.random(),
          }}
        />

        {/* <FormControlLabel control={<Checkbox />} label="สถานะล่าสุด" /> */}
      </GridToolbarContainer>
    );
  }
  /* table data */
  const columns = [
    {
      field: "Status",
      headerName: "Status",
      width: 150,
      renderCell: ({ value }) =>
         
      <Chip
      label={value.toUpperCase()} style={{ color: "white", backgroundColor: value === 'Stock' ? "#28A745" : value === 'Out Stock' ? '#3C5959': '#FFA101' }}
    />
    },
    { field: "ContainerNo", headerName: "Container No", width: 150 },
    { field: "Type", headerName: "Type", width: 80 },
    { field: "Voy", headerName: "Voy", width: 180 },
    { field: "Booking", headerName: "Booking", width: 200 },
    { field: "Saleorder", headerName: "Saleorder No", width: 200 },
    { field: "Location", headerName: "Location ", width: 150 },
    { field: "Zone", headerName: "Zone", width: 150 },
    { field: "Bay", headerName: "Bay", width: 80 },
    { field: "Row", headerName: "Row", width: 80 },
    { field: "Tier", headerName: "Tier", width: 80 },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Button
              variant="contained"
              style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              onClick={() => {
                setIdDialog(params?.row);
                setIdEdit(params?.id);
                handleClickOpen();
                setRow(params?.row?.Row)
                setBay(params?.row?.Bay)
                setTier(params?.row?.Tier)
              }}
            >
              Edit
            </Button>
          </>
        );
      },
    },
  ];

  //fetch Data


  const getData = async () => {
    try {
      const params = { groupId: "G003" };
      const data = await api.get(`api/containermovement/list?${search.startDate ? `startDate=${search.startDate}` : ''}${search.endDate ? `&endDate=${search.endDate}` : ''}&Keyword=${search.Keyword}&ToAction=Train`);
      // console.log(data);
      setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //Submit Edit
  const submitEdit = async () => {
    if (idDialog !== "") {
      const params = {
        StockMovementID: idDialog.StockMovementID,
        ToBay: bay,
        ToRow: row,
        ToTier: tier
      }
      try {
        const res = await api.post("api/containermovement/EditContainermovement", params);
        if (res.meta.status) {
          setOpen(false);
          Swal.fire({
            title: `${res.meta.message}`,
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              getData();

            }
          })
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      alert("กรุณากรอกรหัสตู้");
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [search]);


  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายการคอนเทนเนอร์
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Container List
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Train</Typography>
            <Typography>
              <span>&nbsp;</span> / Container List
            </Typography>
          </Grid>
        </Grid>

        <Box
          sx={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            alignItems: 'center'
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              inputFormat="yyyy/MM/dd"
              value={stDate}
              onChange={(e) => {
                setstDate(moment(e).format("YYYY-MM-DD"));
                // getDate();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label="ระยะเวลาบริการ-เริ่มต้น"
                  style={{

                    width: "15%",
                    marginRight: '10px'
                  }}
                />
              )}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              inputFormat="yyyy/MM/dd"
              value={enDate}
              onChange={(e) => {
                setenDate(moment(e).format("YYYY-MM-DD"));
                // getDate();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="ระยะเวลาบริการ-สิ้นสุด"
                  size="small"
                  style={{
                    marginRight: '10px',
                    width: "15%",
                  }}
                />
              )}
            />
          </LocalizationProvider>

          <TextField value={searchText} onChange={e => setSearchText(e.target.value)} size="small" id="outlined-basic" label="Keyword" variant="outlined" />
          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px"
            }}
            onClick={() => setSearch({
              startDate: stDate ? moment(stDate).format('yyyy-MM-DD') : '',
              endDate: enDate ? moment(enDate).format('yyyy-MM-DD') : '',
              Keyword: searchText,
              ToAction: toAction

            })}
          >
            <SearchIcon />
          </Button>
          {/* <Grid item sx={{ display: "flex", alignItems: "center" }}>
            <SearchData name={data} onsetData={setDataFilter} />
          </Grid> */}
        </Box>


        <Box
          sx={{
            height: 600,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.StockMovementID || "0"}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value == true ? "Active" : "Inactive";
              }
            }}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </Box>
      </Card>
      {MenuActive.find((x) => x.ActionNo === "A042") && (
        <Link to="/Planner/AddContainerList">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit </DialogTitle>
        <DialogContent>
          <DialogContentText>ID = {idDialog.ContainerNo}</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="Bay"
            label="Bay"
            value={bay}
            fullWidth
            variant="standard"
            onChange={(e) => setBay(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="Row"
            label="Row"
            value={row}
            fullWidth
            variant="standard"
            onChange={(e) => setRow(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="Tier"
            label="Tier"
            value={tier}
            fullWidth
            variant="standard"
            onChange={(e) => setTier(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>ยกเลิก</Button>
          <Button
            onClick={() => {

              submitEdit();
            }}
          >
            ยืนยัน
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
